import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Date: any
  DateTime: any
  Decimal: any
}

/** 履歴表示用オブジェクト */
export type AllCustomerObject = {
  Email?: Maybe<Scalars['String']>
  FullName?: Maybe<Scalars['String']>
}

/** 請求書承認 */
export type BillingApprove = {
  approveFlag?: Maybe<Scalars['Boolean']>
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

/** 請求登録 */
export type BillingCreate = {
  /** The created Estimate. */
  estimates?: Maybe<Estimate>
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type BillingCreateInput = {
  /** 宛名 */
  AddressName: Scalars['String']
  /** 作成者 */
  Author?: InputMaybe<Scalars['String']>
  /** ベース見積番号 */
  BasedEstimateNumber?: InputMaybe<Scalars['String']>
  /** 請求額 */
  BillAmount?: InputMaybe<Scalars['Int']>
  /** 請求日 */
  BillingDate?: InputMaybe<Scalars['Date']>
  Categories: Array<InputMaybe<CategoryEstimateInput>>
  /** 入金額 */
  DepositedAmount?: InputMaybe<Scalars['Int']>
  Details: Array<InputMaybe<BillingDetailCreateInput>>
  /** 編集可能フラグ */
  Editable?: InputMaybe<Scalars['Boolean']>
  /** 見積日 */
  EstimateDate: Scalars['Date']
  /** 見積番号 */
  EstimateNumber?: InputMaybe<Scalars['String']>
  EstimateTaxAmount: Array<InputMaybe<EstimateTaxAmountInput>>
  /** 有効期限 */
  ExpirationDate?: InputMaybe<Scalars['Date']>
  /** 接頭語 */
  NumberClass?: InputMaybe<Scalars['String']>
  /** 支払期日 */
  PaymentDeadline?: InputMaybe<Scalars['Date']>
  /** ステータスコード */
  StatusCode: Scalars['Int']
  /** 件名 */
  Subject: Scalars['String']
  /** 補足事項 */
  Supplementary?: InputMaybe<Scalars['String']>
  /** 税抜合計利用料金 */
  TotalAmount: Scalars['Int']
  /** ユーザー */
  User?: InputMaybe<Scalars['String']>
}

export type BillingDetailCreateInput = {
  /** 日数 */
  Days?: InputMaybe<Scalars['Int']>
  /** 減免額 */
  DiscountAmount?: InputMaybe<Scalars['Int']>
  /** 減免率 */
  DiscountPercent?: InputMaybe<Scalars['Int']>
  /** 見積番号 */
  EstimateNumber?: InputMaybe<Scalars['String']>
  /** 税抜金額(単価*数量 or 最大料金) */
  GrossAmount: Scalars['Int']
  /** 最大単価 */
  LimitPrice?: InputMaybe<Scalars['Int']>
  /** 最大数量 */
  LimitQuantity?: InputMaybe<Scalars['Int']>
  /** 税抜利用料金(税抜金額 - 減免額 - 値引額) */
  NetFee: Scalars['Int']
  /** 単価 */
  PackagePrice?: InputMaybe<Scalars['Int']>
  /** 数量 */
  Quantity: Scalars['Int']
  /** 料金カテゴリID */
  RateCategoryId: Scalars['Int']
  /** 料金品目カテゴリID */
  RateItemCategoryId?: InputMaybe<Scalars['Int']>
  /** 品目詳細 */
  RateItemDetail?: InputMaybe<Scalars['String']>
  /** 料金品目ID */
  RateItemId?: InputMaybe<Scalars['Int']>
  /** 品目名 */
  RateItemName: Scalars['String']
  /** 値引額 */
  ReductionAmount?: InputMaybe<Scalars['Int']>
  /** 税区分コード */
  TaxCode: Scalars['String']
  /** 税区分名 */
  TaxName: Scalars['String']
  /** 税率 */
  TaxRate: Scalars['Int']
  /** 単位 */
  Unit: Scalars['String']
  /** 単価 */
  UnitPrice: Scalars['Int']
}

export type BillingDetailObject = {
  /** 日数 */
  Days?: Maybe<Scalars['Int']>
  /** 減免額 */
  DiscountAmount?: Maybe<Scalars['Int']>
  /** 減免率 */
  DiscountPercent?: Maybe<Scalars['Int']>
  /** 見積番号 */
  EstimateNumber?: Maybe<Scalars['String']>
  /** 税抜金額(単価*数量 or 最大料金) */
  GrossAmount: Scalars['Int']
  /** 最大単価 */
  LimitPrice?: Maybe<Scalars['Int']>
  /** 数量 */
  LimitQuantity?: Maybe<Scalars['Int']>
  /** 税抜利用料金(税抜金額 - 減免額 - 値引額) */
  NetFee: Scalars['Int']
  /** パック単価 */
  PackagePrice?: Maybe<Scalars['Int']>
  /** 数量 */
  Quantity: Scalars['Int']
  /** 料金カテゴリID */
  RateCategoryId: Scalars['Int']
  /** 料金品目カテゴリID */
  RateItemCategoryId?: Maybe<Scalars['Int']>
  /** 品目詳細 */
  RateItemDetail?: Maybe<Scalars['String']>
  /** 料金品目ID */
  RateItemId?: Maybe<Scalars['Int']>
  /** 品目名 */
  RateItemName: Scalars['String']
  /** 値引額 */
  ReductionAmount?: Maybe<Scalars['Int']>
  /** 税区分コード */
  TaxCode: Scalars['String']
  /** 税区分名 */
  TaxName: Scalars['String']
  /** 税率 */
  TaxRate: Scalars['Int']
  /** 単位 */
  Unit: Scalars['String']
  /** 単価 */
  UnitPrice: Scalars['Int']
}

export type BillingInfoObject = {
  ApprovalDate?: Maybe<Scalars['DateTime']>
  Author?: Maybe<Scalars['String']>
  EstimateNumber?: Maybe<Scalars['String']>
}

export type BillingObject = {
  AddressName?: Maybe<Scalars['String']>
  Author?: Maybe<Scalars['String']>
  BasedEstimateNumber?: Maybe<Scalars['String']>
  BillAmount?: Maybe<Scalars['Int']>
  BillingDate?: Maybe<Scalars['DateTime']>
  Categories?: Maybe<Array<Maybe<CategoryEstimateObject>>>
  CurrentBillAmount?: Maybe<Scalars['Int']>
  CurrentDepositedAmount?: Maybe<Scalars['Int']>
  DepositedAmount?: Maybe<Scalars['Int']>
  Details?: Maybe<Array<Maybe<BillingDetailObject>>>
  Editable?: Maybe<Scalars['Boolean']>
  Enabled?: Maybe<Scalars['Boolean']>
  EstimateDate?: Maybe<Scalars['DateTime']>
  EstimateNumber?: Maybe<Scalars['String']>
  EstimateTaxAmount?: Maybe<Array<Maybe<EstimateTaxAmountObject>>>
  ExpirationDate?: Maybe<Scalars['DateTime']>
  NumberClass?: Maybe<Scalars['String']>
  PaymentDeadline?: Maybe<Scalars['DateTime']>
  StatusCode?: Maybe<Scalars['Int']>
  Subject?: Maybe<Scalars['String']>
  Supplementary?: Maybe<Scalars['String']>
  TotalAmount?: Maybe<Scalars['Int']>
  User?: Maybe<Scalars['String']>
}

/** 見積登録確認 */
export type BillingResultConfirmation = {
  /** The confirmation Estimate. */
  estimates?: Maybe<EstimateObject>
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type CategoryEstimateInput = {
  /** 税抜基本料金 */
  CategoryBasicFee: Scalars['Int']
  /** カテゴリ別見積税抜利用料金 */
  CategoryNetFee: Scalars['Int']
  /** 見積番号 */
  EstimateNumber?: InputMaybe<Scalars['String']>
  /** 料金カテゴリID */
  RateCategoryId: Scalars['Int']
  /** 減免額 */
  TotalDiscountAmount: Scalars['Int']
  /** 値引額 */
  TotalReductionAmount: Scalars['Int']
}

export type CategoryEstimateObject = {
  /** 税抜基本料金 */
  CategoryBasicFee: Scalars['Int']
  /** カテゴリ別見積税抜利用料金 */
  CategoryNetFee: Scalars['Int']
  /** 見積番号 */
  EstimateNumber?: Maybe<Scalars['String']>
  /** 料金カテゴリID */
  RateCategoryId: Scalars['Int']
  /** 減免額 */
  TotalDiscountAmount: Scalars['Int']
  /** 値引額 */
  TotalReductionAmount: Scalars['Int']
}

export type Estimate = {
  AddressName: Scalars['String']
  Author: Scalars['String']
  BasedEstimateNumber?: Maybe<Scalars['String']>
  BillAmount?: Maybe<Scalars['Int']>
  BillingDate?: Maybe<Scalars['DateTime']>
  Created: Scalars['DateTime']
  DepositedAmount?: Maybe<Scalars['Int']>
  Editable: Scalars['Boolean']
  Enabled?: Maybe<Scalars['Boolean']>
  EstimateDate: Scalars['DateTime']
  EstimateNumber: Scalars['String']
  ExpirationDate?: Maybe<Scalars['DateTime']>
  NumberClass: Scalars['String']
  PaymentDeadline?: Maybe<Scalars['DateTime']>
  StatusCode: Scalars['Int']
  Subject?: Maybe<Scalars['String']>
  Supplementary?: Maybe<Scalars['String']>
  TotalAmount: Scalars['Int']
  Updated: Scalars['DateTime']
  User: Scalars['String']
  id: Scalars['ID']
}

export type EstimateCountObject = {
  EstimateCountNumber?: Maybe<Scalars['Int']>
}

/** 見積登録 */
export type EstimateCreate = {
  /** The created Estimate. */
  estimates?: Maybe<Estimate>
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type EstimateCreateInput = {
  /** 宛名 */
  AddressName: Scalars['String']
  /** 作成者 */
  Author?: InputMaybe<Scalars['String']>
  /** ベース見積番号 */
  BasedEstimateNumber?: InputMaybe<Scalars['String']>
  /** 請求額 */
  BillAmount?: InputMaybe<Scalars['Int']>
  /** 請求日 */
  BillingDate?: InputMaybe<Scalars['Date']>
  Categories?: InputMaybe<Array<InputMaybe<CategoryEstimateInput>>>
  /** 入金額 */
  DepositedAmount?: InputMaybe<Scalars['Int']>
  Details?: InputMaybe<Array<InputMaybe<EstimateDetailCreateInput>>>
  /** 編集可能フラグ */
  Editable?: InputMaybe<Scalars['Boolean']>
  /** 見積日 */
  EstimateDate: Scalars['Date']
  /** 見積番号 */
  EstimateNumber?: InputMaybe<Scalars['String']>
  EstimateTaxAmount?: InputMaybe<Array<InputMaybe<EstimateTaxAmountInput>>>
  /** 有効期限 */
  ExpirationDate?: InputMaybe<Scalars['Date']>
  /** 接頭語 */
  NumberClass?: InputMaybe<Scalars['String']>
  /** 支払期日 */
  PaymentDeadline?: InputMaybe<Scalars['Date']>
  /** ステータスコード */
  StatusCode: Scalars['Int']
  /** 件名 */
  Subject: Scalars['String']
  /** 補足事項 */
  Supplementary?: InputMaybe<Scalars['String']>
  /** 税抜合計利用料金 */
  TotalAmount: Scalars['Int']
  /** ユーザー */
  User?: InputMaybe<Scalars['String']>
}

export type EstimateDetailCreateInput = {
  /** 日数 */
  Days?: InputMaybe<Scalars['Int']>
  /** 減免額 */
  DiscountAmount?: InputMaybe<Scalars['Int']>
  /** 減免率 */
  DiscountPercent?: InputMaybe<Scalars['Int']>
  /** 見積番号 */
  EstimateNumber?: InputMaybe<Scalars['String']>
  /** 税抜金額(単価*数量 or 最大料金) */
  GrossAmount: Scalars['Int']
  /** 最大単価 */
  LimitPrice?: InputMaybe<Scalars['Int']>
  /** 最大数量 */
  LimitQuantity?: InputMaybe<Scalars['Int']>
  /** 税抜利用料金(税抜金額 - 減免額 - 値引額) */
  NetFee: Scalars['Int']
  /** パック単価 */
  PackagePrice?: InputMaybe<Scalars['Int']>
  /** 数量 */
  Quantity: Scalars['Int']
  /** 料金カテゴリID */
  RateCategoryId: Scalars['Int']
  /** 料金品目カテゴリID */
  RateItemCategoryId: Scalars['Int']
  /** 品目詳細 */
  RateItemDetail?: InputMaybe<Scalars['String']>
  /** 料金品目ID */
  RateItemId: Scalars['Int']
  /** 品目名 */
  RateItemName: Scalars['String']
  /** 値引額 */
  ReductionAmount?: InputMaybe<Scalars['Int']>
  /** 税区分コード */
  TaxCode: Scalars['String']
  /** 税区分名 */
  TaxName: Scalars['String']
  /** 税率 */
  TaxRate: Scalars['Int']
  /** 単位 */
  Unit: Scalars['String']
  /** 単価 */
  UnitPrice: Scalars['Int']
}

export type EstimateDetailObject = {
  /** 日数 */
  Days?: Maybe<Scalars['Int']>
  /** 減免額 */
  DiscountAmount?: Maybe<Scalars['Int']>
  /** 減免率 */
  DiscountPercent?: Maybe<Scalars['Int']>
  /** 見積番号 */
  EstimateNumber?: Maybe<Scalars['String']>
  /** 税抜金額(単価*数量 or 最大料金) */
  GrossAmount: Scalars['Int']
  /** 最大単価 */
  LimitPrice?: Maybe<Scalars['Int']>
  /** 数量 */
  LimitQuantity?: Maybe<Scalars['Int']>
  /** 税抜利用料金(税抜金額 - 減免額 - 値引額) */
  NetFee: Scalars['Int']
  /** パック単価 */
  PackagePrice?: Maybe<Scalars['Int']>
  /** 数量 */
  Quantity: Scalars['Int']
  /** 料金カテゴリID */
  RateCategoryId: Scalars['Int']
  /** 料金品目カテゴリID */
  RateItemCategoryId: Scalars['Int']
  /** 品目詳細 */
  RateItemDetail?: Maybe<Scalars['String']>
  /** 料金品目ID */
  RateItemId: Scalars['Int']
  /** 品目名 */
  RateItemName: Scalars['String']
  /** 値引額 */
  ReductionAmount?: Maybe<Scalars['Int']>
  /** 税区分コード */
  TaxCode: Scalars['String']
  /** 税区分名 */
  TaxName: Scalars['String']
  /** 税率 */
  TaxRate: Scalars['Int']
  /** 単位 */
  Unit: Scalars['String']
  /** 単価 */
  UnitPrice: Scalars['Int']
}

/** 正式見積依頼 */
export type EstimateFormalRequestCreate = {
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type EstimateObject = {
  AddressName?: Maybe<Scalars['String']>
  Author?: Maybe<Scalars['String']>
  BasedEstimateNumber?: Maybe<Scalars['String']>
  BillAmount?: Maybe<Scalars['Int']>
  BillingDate?: Maybe<Scalars['DateTime']>
  Categories?: Maybe<Array<Maybe<CategoryEstimateObject>>>
  DepositedAmount?: Maybe<Scalars['Int']>
  Details?: Maybe<Array<Maybe<EstimateDetailObject>>>
  Editable?: Maybe<Scalars['Boolean']>
  Enabled?: Maybe<Scalars['Boolean']>
  EstimateDate?: Maybe<Scalars['DateTime']>
  EstimateNumber?: Maybe<Scalars['String']>
  EstimateTaxAmount?: Maybe<Array<Maybe<EstimateTaxAmountObject>>>
  ExpirationDate?: Maybe<Scalars['DateTime']>
  NumberClass?: Maybe<Scalars['String']>
  PaymentDeadline?: Maybe<Scalars['DateTime']>
  StatusCode?: Maybe<Scalars['Int']>
  Subject?: Maybe<Scalars['String']>
  Supplementary?: Maybe<Scalars['String']>
  TotalAmount?: Maybe<Scalars['Int']>
  User?: Maybe<Scalars['String']>
}

/** 見積登録確認 */
export type EstimateResultConfirmation = {
  /** The confirmation Estimate. */
  estimates?: Maybe<EstimateObject>
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

/** 見積税額受け取りクラス */
export type EstimateTaxAmountInput = {
  /** 見積番号 */
  EstimateNumber?: InputMaybe<Scalars['String']>
  /** 税額 (税抜利用料金*税率)  */
  TaxAmount: Scalars['Int']
  /** 税区分コード */
  TaxCode: Scalars['String']
  /** 税区分名 */
  TaxName: Scalars['String']
  /** 税率 */
  TaxRate: Scalars['Int']
  /** 課税対象額 */
  TaxableAmount: Scalars['Int']
}

/** 見積税額受け取りクラス */
export type EstimateTaxAmountObject = {
  /** 見積番号 */
  EstimateNumber?: Maybe<Scalars['String']>
  /** 税額 (税抜利用料金*税率)  */
  TaxAmount: Scalars['Int']
  /** 税区分コード */
  TaxCode: Scalars['String']
  /** 税区分名 */
  TaxName: Scalars['String']
  /** 税率 */
  TaxRate: Scalars['Int']
  /** 課税対象額 */
  TaxableAmount: Scalars['Int']
}

/** レポート出力 */
export type ExportEstimate = {
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
  url?: Maybe<Scalars['String']>
}

export type Mutation = {
  /** 請求書承認 */
  billingApprove?: Maybe<BillingApprove>
  /** 請求登録 */
  billingCreate?: Maybe<BillingCreate>
  /** 見積登録確認 */
  billingResultConfirmation?: Maybe<BillingResultConfirmation>
  /** 見積登録 */
  estimateCreate?: Maybe<EstimateCreate>
  /** 正式見積依頼 */
  estimateFormalRequestCreate?: Maybe<EstimateFormalRequestCreate>
  /** 見積登録確認 */
  estimateResultConfirmation?: Maybe<EstimateResultConfirmation>
  /** レポート出力 */
  exportEstimate?: Maybe<ExportEstimate>
  /** 採番登録 */
  numberingCreate?: Maybe<NumberingCreate>
  /** 料金カテゴリ登録 */
  rateCategoryCreate?: Maybe<RateCategoryCreate>
  /** 料金カテゴリ削除 */
  rateCategoryDelete?: Maybe<RateCategoryDelete>
  /** 料金カテゴリ更新 */
  rateCategoryUpdate?: Maybe<RateCategoryUpdate>
  /** 料金品目カテゴリ登録 */
  rateItemCategoryCreate?: Maybe<RateItemCategoryCreate>
  /** 料金品目カテゴリ削除 */
  rateItemCategoryDelete?: Maybe<RateItemCategoryDelete>
  /** 料金品目カテゴリ更新 */
  rateItemCategoryUpdate?: Maybe<RateItemCategoryUpdate>
  /** 料金品目登録 */
  rateItemCreate?: Maybe<RateItemCreate>
  /** 料金品目削除 */
  rateItemDelete?: Maybe<RateItemDelete>
  /** 料金品目更新 */
  rateItemUpdate?: Maybe<RateItemUpdate>
  /** 消費税登録 */
  rateTaxCreate?: Maybe<RateTaxCreate>
  /** 消費税削除 */
  rateTaxDelete?: Maybe<RateTaxDelete>
  /** 消費税更新 */
  rateTaxUpdate?: Maybe<RateTaxUpdate>
}

export type MutationBillingApproveArgs = {
  EstimateNumber: Scalars['String']
}

export type MutationBillingCreateArgs = {
  input: BillingCreateInput
}

export type MutationBillingResultConfirmationArgs = {
  input: EstimateCreateInput
}

export type MutationEstimateCreateArgs = {
  input: EstimateCreateInput
}

export type MutationEstimateFormalRequestCreateArgs = {
  EstimateNumber: Scalars['String']
}

export type MutationEstimateResultConfirmationArgs = {
  input: EstimateCreateInput
}

export type MutationExportEstimateArgs = {
  estimateNumber?: InputMaybe<Scalars['String']>
}

export type MutationNumberingCreateArgs = {
  input: NumberingCreateInput
}

export type MutationRateCategoryCreateArgs = {
  input: RateCategoryCreateInput
}

export type MutationRateCategoryDeleteArgs = {
  Id: Scalars['ID']
}

export type MutationRateCategoryUpdateArgs = {
  Id: Scalars['ID']
  input: RateCategoryUpdateInput
}

export type MutationRateItemCategoryCreateArgs = {
  input: RateItemCategoryCreateInput
}

export type MutationRateItemCategoryDeleteArgs = {
  Id?: InputMaybe<Scalars['ID']>
}

export type MutationRateItemCategoryUpdateArgs = {
  Id: Scalars['ID']
  input: RateItemCategoryUpdateInput
}

export type MutationRateItemCreateArgs = {
  input: RateItemCreateInput
}

export type MutationRateItemDeleteArgs = {
  Id?: InputMaybe<Scalars['ID']>
}

export type MutationRateItemUpdateArgs = {
  Id: Scalars['ID']
  input: RateItemUpdateInput
}

export type MutationRateTaxCreateArgs = {
  input: RateTaxCreateInput
}

export type MutationRateTaxDeleteArgs = {
  Id: Scalars['ID']
}

export type MutationRateTaxUpdateArgs = {
  Id: Scalars['ID']
  input: RateTaxUpdateInput
}

export type Numbering = {
  CurrentValue: Scalars['Int']
  Id: Scalars['ID']
  InitValue: Scalars['Int']
  KeyText: Scalars['String']
  MaxValue: Scalars['Int']
  MinValue: Scalars['Int']
  NumberClass: Scalars['String']
  ValueLength: Scalars['Int']
}

/** 採番登録 */
export type NumberingCreate = {
  message?: Maybe<Scalars['String']>
  /** The created RateCategory. */
  numbering?: Maybe<Array<Maybe<Numbering>>>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type NumberingCreateInput = {
  /** 何か月分作成したいか */
  range: Scalars['Int']
  /** YYMM:作成したい年月日 */
  startDate: Scalars['String']
}

export type QueryRoot = {
  /** 料金品目カテゴリの情報を全件取得 */
  allRateItemCategories?: Maybe<Array<Maybe<RateItemCategory>>>
  /** 料金品目の情報を全件取得 */
  allRateItems?: Maybe<Array<Maybe<RateItem>>>
  /** 消費税の情報を全件取得 */
  allRateTaxes?: Maybe<Array<Maybe<RateTax>>>
  /** 施設予約の全ユーザーを取得 */
  allUserData?: Maybe<Array<Maybe<AllCustomerObject>>>
  /** ユーザーの権限を取得 */
  auth0PermissionLevel?: Maybe<Scalars['String']>
  /** 見積番号に紐づく請求書情報を取得 */
  billingInfoByEstimateNumber?: Maybe<BillingInfoObject>
  /** 見積番号に紐づく請求詳細情報を取得 */
  billingResult?: Maybe<BillingObject>
  /** 有効な消費税の情報を取得 */
  enabledRateTaxes?: Maybe<Array<Maybe<RateTax>>>
  /** 見積番号に紐づく見積詳細情報を取得 */
  estimateResult?: Maybe<EstimateObject>
  /** 指定された期間中に作成された見積数をカウント */
  getEstimateCount?: Maybe<EstimateCountObject>
  /** 有効な料金品目カテゴリの情報を取得 */
  rateItemCategories?: Maybe<Array<Maybe<RateItemCategory>>>
  /** 有効な料金品目の情報を取得 */
  rateItems?: Maybe<Array<Maybe<RateItem>>>
  /** 料金品目IDに紐づく料金品目を取得 */
  rateItemsById?: Maybe<RateItemsWithRateItemCategoryName>
  /** メールアドレスに紐づく見積を取得 */
  searchByEmailAddress?: Maybe<Array<Maybe<Estimate>>>
}

export type QueryRootAuth0PermissionLevelArgs = {
  email?: InputMaybe<Scalars['String']>
}

export type QueryRootBillingInfoByEstimateNumberArgs = {
  EstimateNumber?: InputMaybe<Scalars['String']>
}

export type QueryRootBillingResultArgs = {
  Email?: InputMaybe<Scalars['String']>
  EstimateNumber?: InputMaybe<Scalars['String']>
}

export type QueryRootEstimateResultArgs = {
  Email?: InputMaybe<Scalars['String']>
  EstimateNumber?: InputMaybe<Scalars['String']>
}

export type QueryRootGetEstimateCountArgs = {
  EndDate?: InputMaybe<Scalars['DateTime']>
  StartDate?: InputMaybe<Scalars['DateTime']>
}

export type QueryRootRateItemsByIdArgs = {
  rateItemCategoryId?: InputMaybe<Scalars['ID']>
}

export type QueryRootSearchByEmailAddressArgs = {
  Email?: InputMaybe<Scalars['String']>
}

export type RateCategory = {
  Id: Scalars['Int']
  RateCategoryName: Scalars['String']
}

/** 料金カテゴリ登録 */
export type RateCategoryCreate = {
  message?: Maybe<Scalars['String']>
  /** The created RateCategory. */
  rateCategory?: Maybe<RateCategory>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateCategoryCreateInput = {
  Id: Scalars['Int']
  RateCategoryName: Scalars['String']
}

/** 料金カテゴリ削除 */
export type RateCategoryDelete = {
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

/** 料金カテゴリ更新 */
export type RateCategoryUpdate = {
  message?: Maybe<Scalars['String']>
  rateCategory?: Maybe<RateCategory>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateCategoryUpdateInput = {
  RateCategoryName: Scalars['String']
}

export type RateItem = {
  Created: Scalars['DateTime']
  Disabled: Scalars['Boolean']
  Hidden: Scalars['Boolean']
  Id: Scalars['ID']
  LimitPrice?: Maybe<Scalars['Int']>
  LimitQuantity?: Maybe<Scalars['Int']>
  PackagePrice?: Maybe<Scalars['Int']>
  ParentRateItemId?: Maybe<Scalars['Int']>
  RateItemCategoryId: Scalars['Int']
  RateItemDetail?: Maybe<Scalars['String']>
  RateItemName: Scalars['String']
  RateItemUnit: Scalars['String']
  RateItemUnitPrice: Scalars['Int']
  SortOrder: Scalars['Int']
  TaxCode: Scalars['String']
  Unselectable: Scalars['Boolean']
  Updated: Scalars['DateTime']
}

export type RateItemCategory = {
  Created: Scalars['DateTime']
  Hidden: Scalars['Boolean']
  Id: Scalars['ID']
  RateCategoryId: Scalars['Int']
  RateItemCategoryName: Scalars['String']
  SortOrder: Scalars['Int']
  Updated: Scalars['DateTime']
}

/** 料金品目カテゴリ登録 */
export type RateItemCategoryCreate = {
  message?: Maybe<Scalars['String']>
  /** The created RateItemCategory. */
  rateItemCategory?: Maybe<RateItemCategory>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateItemCategoryCreateInput = {
  Hidden: Scalars['Boolean']
  RateCategoryId: Scalars['Int']
  RateItemCategoryName: Scalars['String']
  SortOrder: Scalars['Int']
}

/** 料金品目カテゴリ削除 */
export type RateItemCategoryDelete = {
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

/** 料金品目カテゴリ更新 */
export type RateItemCategoryUpdate = {
  message?: Maybe<Scalars['String']>
  rateItemCategory?: Maybe<RateItemCategory>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateItemCategoryUpdateInput = {
  Hidden?: InputMaybe<Scalars['Boolean']>
  RateCategoryId?: InputMaybe<Scalars['Int']>
  RateItemCategoryName?: InputMaybe<Scalars['String']>
  SortOrder?: InputMaybe<Scalars['Int']>
}

/** 料金品目登録 */
export type RateItemCreate = {
  message?: Maybe<Scalars['String']>
  /** The created RateItem. */
  rateItem?: Maybe<RateItem>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateItemCreateInput = {
  Hidden: Scalars['Boolean']
  LimitPrice?: InputMaybe<Scalars['Int']>
  LimitQuantity?: InputMaybe<Scalars['Int']>
  PackagePrice?: InputMaybe<Scalars['Int']>
  ParentRateItemId?: InputMaybe<Scalars['Int']>
  RateItemCategoryId: Scalars['Int']
  RateItemDetail?: InputMaybe<Scalars['String']>
  RateItemName: Scalars['String']
  RateItemUnit: Scalars['String']
  RateItemUnitPrice: Scalars['Int']
  SortOrder: Scalars['Int']
  TaxCode: Scalars['String']
  Unselectable: Scalars['Boolean']
}

/** 料金品目削除 */
export type RateItemDelete = {
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

/** 料金品目更新 */
export type RateItemUpdate = {
  message?: Maybe<Scalars['String']>
  rateItem?: Maybe<RateItem>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateItemUpdateInput = {
  Hidden?: InputMaybe<Scalars['Boolean']>
  LimitPrice?: InputMaybe<Scalars['Int']>
  LimitQuantity?: InputMaybe<Scalars['Int']>
  PackagePrice?: InputMaybe<Scalars['Int']>
  ParentRateItemId?: InputMaybe<Scalars['Int']>
  RateItemCategoryId?: InputMaybe<Scalars['Int']>
  RateItemDetail?: InputMaybe<Scalars['String']>
  RateItemName?: InputMaybe<Scalars['String']>
  RateItemUnit?: InputMaybe<Scalars['String']>
  RateItemUnitPrice?: InputMaybe<Scalars['Int']>
  SortOrder?: InputMaybe<Scalars['Int']>
  TaxCode?: InputMaybe<Scalars['String']>
  Unselectable?: InputMaybe<Scalars['Boolean']>
}

export type RateItemsWithRateItemCategoryName = {
  RateItemCategoryName?: Maybe<Scalars['String']>
  RateItems?: Maybe<Array<Maybe<RateItem>>>
}

export type RateTax = {
  Created: Scalars['DateTime']
  From: Scalars['Date']
  Id: Scalars['ID']
  Rate: Scalars['Decimal']
  TaxCode: Scalars['String']
  TaxName: Scalars['String']
  Updated: Scalars['DateTime']
}

/** 消費税登録 */
export type RateTaxCreate = {
  errorCode?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  /** The created ratetax. */
  rateTax?: Maybe<RateTax>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateTaxCreateInput = {
  From: Scalars['Date']
  Rate: Scalars['Decimal']
  TaxCode: Scalars['String']
  TaxName: Scalars['String']
}

/** 消費税削除 */
export type RateTaxDelete = {
  message?: Maybe<Scalars['String']>
  succeeded?: Maybe<Scalars['Boolean']>
}

/** 消費税更新 */
export type RateTaxUpdate = {
  errorCode?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  rateTax?: Maybe<RateTax>
  succeeded?: Maybe<Scalars['Boolean']>
}

export type RateTaxUpdateInput = {
  From?: InputMaybe<Scalars['Date']>
  Rate?: InputMaybe<Scalars['Decimal']>
  TaxName?: InputMaybe<Scalars['String']>
}

export type Auth0PermissionLevelQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>
}>

export type Auth0PermissionLevelQuery = { auth0PermissionLevel?: string | null }

export const Auth0PermissionLevelDocument = gql`
  query auth0PermissionLevel($email: String) {
    auth0PermissionLevel(email: $email)
  }
`

/**
 * __useAuth0PermissionLevelQuery__
 *
 * To run a query within a React component, call `useAuth0PermissionLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuth0PermissionLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuth0PermissionLevelQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAuth0PermissionLevelQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Auth0PermissionLevelQuery,
    Auth0PermissionLevelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<Auth0PermissionLevelQuery, Auth0PermissionLevelQueryVariables>(
    Auth0PermissionLevelDocument,
    options
  )
}
export function useAuth0PermissionLevelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Auth0PermissionLevelQuery,
    Auth0PermissionLevelQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<Auth0PermissionLevelQuery, Auth0PermissionLevelQueryVariables>(
    Auth0PermissionLevelDocument,
    options
  )
}
export type Auth0PermissionLevelQueryHookResult = ReturnType<typeof useAuth0PermissionLevelQuery>
export type Auth0PermissionLevelLazyQueryHookResult = ReturnType<
  typeof useAuth0PermissionLevelLazyQuery
>
export type Auth0PermissionLevelQueryResult = Apollo.QueryResult<
  Auth0PermissionLevelQuery,
  Auth0PermissionLevelQueryVariables
>
